__webpack_require__.p = "https://gizmeon.mdc.akamaized.net/files/web/staging/tbi-template/build-v1.0.0/";